import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEXT } from "../../../../js/lib/ext/Ext";
// import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { LocationConfigurationHolder } from "@tlc/ls2pac/components/LocationConfiguration";



export const BulkActionControl = (function ( $ ) {

	var containerClass = LS2PAC_CONSTANTS.Ids.SearchPage.bulkActionControlContainer,
		controlClass = LS2PAC_CONSTANTS.Ids.SearchPage.bulkActionControl,
		optionExt = null,
		sortingData = null,
		hasEvents = false,
		options = null;

	var unsubscribeFunctions = [];

	var runLocalConfigCheck = function () {
		$.each( options, function ( i, option ) {
			if( option.localConfigCheck ) {
				var currentOption = $( "." + controlClass + " option[value='" + option.value + "']" );
				if( option.localConfigCheck() === true ) {
					if( currentOption.length === 0 ) {
						$( "." + controlClass ).append( optionExt.populate( option ) );
					}
				}
				else {
					currentOption.remove();
				}
			}
		} );
	};

	return {
		reset:        function () {
			$( "." + controlClass ).val( "" );
		},
		disable:      function () {
			$( "." + controlClass ).attr( LS2PAC_CONSTANTS.CssClasses.disabled, LS2PAC_CONSTANTS.CssClasses.disabled );
		},
		enable:       function () {
			$( "." + controlClass ).prop("disabled", false);
		},
		show:         function () {
			$( "." + containerClass ).show();
		},
		hide:         function () {
			$( "." + containerClass ).hide();
		},
		init:         function ( initOptions ) {
			options = initOptions;
			optionExt = TLCEXT.Template( "<option value=\"{value}\">{text}</option>" );
			this.addListeners();
			this.addEvents();
			this.render();
		},
		render:       function () {
			var selectBox = $( "." + controlClass );
			selectBox.empty();
			$.each( options, function ( index, item ) {
				selectBox.append( optionExt.populate( item ) );
			} );
			runLocalConfigCheck();
		},
		addListeners: function () {
			var _this = this;
			const onSearchGuid = TLCEventManager.addListener( LS2PAC_CONSTANTS.Events.onSearch, function ( event ) {
				$( "." + controlClass ).attr( LS2PAC_CONSTANTS.CssClasses.disabled, LS2PAC_CONSTANTS.CssClasses.disabled );
			} );
			unsubscribeFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onSearch, onSearchGuid));

			const onPagingModelResponseGuid = TLCEventManager.addListener( TLC_CONSTANTS.Events.onPagingModelResponse, function ( event ) {
				$( "." + controlClass ).attr( LS2PAC_CONSTANTS.CssClasses.disabled, LS2PAC_CONSTANTS.CssClasses.disabled );
			} );
			unsubscribeFunctions.push(() => TLCEventManager.removeListener(TLC_CONSTANTS.Events.onPagingModelResponse, onPagingModelResponseGuid));

			const onLogoutResponseGuid = TLCEventManager.addListener( LS2PAC_CONSTANTS.Events.onLogoutResponse, function ( event ) {
				$( "." + controlClass ).attr( LS2PAC_CONSTANTS.CssClasses.disabled, LS2PAC_CONSTANTS.CssClasses.disabled );
				runLocalConfigCheck();
			} );
			unsubscribeFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onLogoutResponse, onLogoutResponseGuid));

			const onLoginResponseGuid = TLCEventManager.addListener( LS2PAC_CONSTANTS.Events.onLoginResponse, function ( event ) {
				runLocalConfigCheck();
			} );
			unsubscribeFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onLoginResponse, onLoginResponseGuid));

			unsubscribeFunctions.push(
				LocationConfigurationHolder.subscribe( ( ) => 
				{
					runLocalConfigCheck();
				}
			));
		},
		addEvents:    function () {
			if( hasEvents === false ) {
				var _this = this;
				$( "." + containerClass ).on("change", "." + controlClass, function ( event ) {
					var currentVal = event.currentTarget.value;
					$.each( options, function ( i, option ) {
						if( currentVal == option.value && option.onChange ) {
							option.onChange( event );
						}
					} );
				} );
				hasEvents = true;
			}
		},
		cleanup: function(){
			// removeListeners
			unsubscribeFunctions.forEach((unsubscribe) => unsubscribe());

			// removeEvents
			$( "." + containerClass ).off("change", "." + controlClass);
			hasEvents = false;
		}
	}

})( jQuery );
